import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { getErrorString } from '../../utils';
import { fetchSubscriptions } from '../../api/subscriptions-api';
import { setQuickLinks } from 'reducers/quick-links-slice';

const initialState = {
  activeColumns: [],
  subscriptions: [],
  loading: true,
  pending: false,
  pagination: {},
};

export const fetchSubscriptionsListing = createAsyncThunk(
  'subscriptions/listing',
  async (updatedParamsObject = {}, { dispatch }) => {
  try {
    const paramsObj = {
      ...updatedParamsObject,
    };
    const res = await fetchSubscriptions(paramsObj, '');
    if (res?.status) {
      dispatch(setQuickLinks(res?.user_filters));
    }
    return res;
  } catch (error) {
    toast.error(getErrorString(error));
  }
  },
);

const SubscriptionsSlice = createSlice({
  name: 'subscriptions',
  initialState,
  reducers: {
    setSubscriptionsLoading: (state, action) => {
      state.loading = action?.payload?.loading;
    },
    setSubscriptionsActiveColumn: (state, action) => {
      state.activeColumns = action?.payload?.activeColumns;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchSubscriptionsListing.pending, (state) => {
        state.pending = true;
      })
      .addCase(fetchSubscriptionsListing.fulfilled, (state, action) => {
        if (state.loading) {
          //means first time loading
          state.activeColumns = action?.payload?.active_columns || [];
        }
        state.subscriptions = action?.payload?.data || [];
        state.loading = false;
        state.pending = false;
        state.pagination = action?.payload?.meta?.pagination || {};
      })
      .addCase(fetchSubscriptionsListing.rejected, (state) => {
        state.loading = false;
        state.pending = false;
      });
  },
});

export const { setSubscriptionsLoading, setSubscriptionsActiveColumn } = SubscriptionsSlice.actions;
export default SubscriptionsSlice.reducer;
